import React, {Component, PropTypes} from 'react';
import CSSModules from 'react-css-modules'
// import {Doughnut} from 'react-chartjs'
import Loader from 'react-loader'
import { Row, Col } from 'react-flexbox-grid'
import {SlideDown} from 'react-slidedown'
import ReactTooltip from 'react-tooltip'
import config from 'config'
import format from '../../helpers/format'
import container from '../../helpers/container'
import {
  ContainerDivs,
  Link,
  LinkIcon,
  // AssetManagerLetter,
  PlanScorecardHeader,
  // PlanScorecardQuickResults,
  PlanScorecardNameHeader,
  PlanScorecardDefaultScorecard,
  // PlanScorecardResultModal,
  PlanScorecardTakeActionShare,
  PlanScorecardDefaultAllocation,
  PlanScorecardFundIssueAccordion,
  PlanScorecardFundDetails,
  PlanScorecardIssueAllocations,
  PlanScorecardSustainableAccess,
  PlanScorecardToActionCenter,
  PlanScorecardSelfDirectedOption,
  PlanScorecardInvestmentOptions,
  PlanScorecardSourceData,
  PlanScorecardCompanyLetter,
  PlanScorecardShareholderResolution,
  // XsBr
} from '../../components'

import Styles from './PlanScorecard.css'


@CSSModules(Styles, {allowMultiple:true})
export default class PlanScorecard extends Component {
  static contextTypes =  {
    router: PropTypes.object.isRequired
  }
  constructor(props) {
    super(props)
    this.state = {
      showDefaultTargetDateScorecard: false,
      showSriOptionScorecards: false,
      defaultSelect: {
        label: 'Vanguard Target Retirement 2050 Fund',
        value: 'FSUSA072BK'
      }
    }
  }

  render() {
    if (!this.props.params.planId) {
      this.context.router.push(config.routes.plans)
      return (
        <div styleName='page'>
          <Loader
            options={{scale: 0.70, top:'2.0rem'}}
            loaded={ false }
          />
        </div>
      )
    }

    const { planId } = this.props.params
    const planData = config.plansSource[planId]

    if (!planData) {
      this.context.router.push(config.routes.plans)
      return (
        <div styleName='page'>
          <Loader
            options={{scale: 0.70, top:'2.0rem'}}
            loaded={false}
          />
        </div>
      )
    }

    const title = planData.short_name
    const description = `See how ${planData.plan_short_name} is rated on environmental and social sustainability issues.`
    const url = config.domain + config.routes.plans + '/' + planId

    //
    const sriIcon = require( '../../../static/images/sri.png' )
    // const fffIcon = require( '../../../static/images/icons/fff-icon.svg' )
    // const dffIcon = require( '../../../static/images/icons/dff-icon.svg' )
    // const gefIcon = require( '../../../static/images/icons/gef-icon.svg' )
    // const gffIcon = require( '../../../static/images/icons/gff-icon.svg' )
    // const pffIcon = require( '../../../static/images/icons/pff-icon.svg' )
    // const wffIcon = require( '../../../static/images/icons/wff-icon.svg' )
    // const tffIcon = require( '../../../static/images/icons/tff-icon.svg' )
    //

    // calculate allocation %s
    const allocationStats = {}
    const allocationLabels = ['default','equity','bond','other','sri']
    allocationLabels.map((e, i) => {
      allocationStats[e] = {
        usd: format.money(planData.allocations[e], true, true),
        perc: Math.round(planData.allocations[e] / planData.plan_assets * 100.0),
        percOther: 100 - Math.round(planData.allocations[e] / planData.plan_assets * 100.0),
        percStr: format.perc(planData.allocations[e] / planData.plan_assets)
      }
      return null
    })
    allocationStats.default.count = planData.default_plan_options.length
    allocationStats.equity.count = planData.equity_plan_options.length
    allocationStats.bond.count = planData.bond_plan_options.length
    allocationStats.other.count = planData.other_plan_options.length
    allocationStats.sri.count = planData.plan_option_sri_count

    const planOptionMapFn = (e, i) => {
      const planOptionFull = config.planOptionsSource[e[0]]
      if (!planOptionFull) {
        return {
          investment_vehicle_id: '',
          label: e[1],
          assets: e[2],
          fund_type: e[3]
        }
      }
      planOptionFull.investment_vehicle_id = e[0]
      planOptionFull.label = e[1]
      planOptionFull.assets = e[2]
      planOptionFull.fund_type = e[3]
      return planOptionFull
    }

    planData.default_plan_options.sort((a, b) => (a[2] < b[2]) ? 1 : -1)
    planData.equity_plan_options.sort((a, b) => (a[2] < b[2]) ? 1 : -1)
    planData.bond_plan_options.sort((a, b) => (a[2] < b[2]) ? 1 : -1)
    planData.other_plan_options.sort((a, b) => (a[2] < b[2]) ? 1 : -1)
    const planOptions = {
      ratedAs: planData.rated_as_option.map(planOptionMapFn),
      default: planData.default_plan_options.map(planOptionMapFn),
      equity: planData.equity_plan_options.map(planOptionMapFn),
      bond: planData.bond_plan_options.map(planOptionMapFn),
      other: planData.other_plan_options.map(planOptionMapFn),
      all: planData.default_plan_options.concat(
        planData.equity_plan_options,
        planData.bond_plan_options,
        planData.other_plan_options
      ).map(planOptionMapFn).sort((a, b) => b.assets - a.assets)
    }

    // This will be the 2050 fund of the target date series
    // that is the default plan lineup
    const currDefaultFund = planOptions.ratedAs.filter((e, i) => {
      return true
    }).pop()

    const currSRIFunds = planOptions.equity.filter((e, i) => {
      if (e.sustainable_investment >= 1) {
        return true
      }
      return false
    })

    console.log('hi here temp')
    console.log('currSRIFunds')
    console.log(currSRIFunds)
    console.log('planOptions.equity')
    console.log(planOptions.equity)

    //
    return (
      <div>
        {container.helmet(title, description, url)}

        { /*
          Object.keys(config.plansBondsSource).includes(this.props.params.planId) ?
            <div styleName='bond-clickthrough'>
              <ContainerDivs >
                <Link
                  to={config.routes.fossilFuelBondsIn401ks}
                  title='Fossil Fuel Bonds in 401(k)s'
                >
                  New! See more about this plan in our new analysis of
                  Fossil Fuel Bonds in 401(k)s<LinkIcon />
                </Link>
              </ContainerDivs >
            </div> :
            null
        */ }

        <PlanScorecardHeader planId={planId} planData={planData} />
        
        <div styleName='gray-bckgrnd' id='scores'>
          <ContainerDivs >
            { /*
              <PlanScorecardQuickResults planData={planData} showLabels/>
            */ }

            <PlanScorecardNameHeader planData={planData} />

            <PlanScorecardDefaultScorecard fund={currDefaultFund}/>

            { /* <AssetManagerLetter fundFamilyName={planData.default_fund_manager}/> */ }

            <PlanScorecardTakeActionShare
              description={description}
              url={url}
            />

            <br/>
            <br/>

            <PlanScorecardDefaultAllocation
              allocationStats={allocationStats}
              planData={planData}
            />

            <button
              styleName='section-slidedown-button'
              onClick={
                (e)=>{
                  this.setState({
                    showDefaultTargetDateScorecard: !this.state.showDefaultTargetDateScorecard
                  })
                }
              }
            >
              <h3 styleName='section-slidedown-label'>
                Target date scorecard
              </h3>
              <div styleName='section-slidedown-icon'>
                <LinkIcon
                  faclass={
                    this.state.showDefaultTargetDateScorecard ?
                      'fa-angle-up' :
                      'fa-angle-down'
                  }
                />
              </div>
            </button>
            <br/>
            <SlideDown>
              {
                this.state.showDefaultTargetDateScorecard ?
                  (
                    <Row>
                      <Col xs={12} sm={12} md={9}>
                        <div styleName='fund-card'>

                          <div styleName='title-select-wrap'>
                            <div styleName='datatitle'>
                              {currDefaultFund.fund_legal_name}
                            </div>
                          </div>

                          { /* accordion for ESG sectors with slide downs */ }
                          <PlanScorecardFundIssueAccordion
                            fund={currDefaultFund}
                          />

                          { /* render the fund details slidedown table */ }
                          <PlanScorecardFundDetails
                            fund={currDefaultFund}
                          />
                        </div>
                      </Col>
                    </Row>
                  ) :
                  null
              }
            </SlideDown>

            <br/>
            <br/>
            <br/>

            { /* ESG-SECTOR ALLOCATION CHART AND TABLES */ }
            <PlanScorecardIssueAllocations
              planData={planData}
            />


            { /*
                SUSTAINABLE OPTIONS
                Details for any sustainable options
            */ }
            <PlanScorecardSustainableAccess
              planData={planData}
              allocationStats={allocationStats}
            />

            {
              planData.plan_option_sri_count && planData.plan_option_sri_count>0 ?
                (
                  <div>
                    <button
                      styleName='section-slidedown-button'
                      onClick={
                        (e)=>{
                          this.setState({
                            showSriOptionScorecards: !this.state.showSriOptionScorecards
                          })
                        }
                      }
                    >
                      <h3 styleName='section-slidedown-label'>
                        Sustainable plan options
                      </h3>
                      <div styleName='section-slidedown-icon'>
                        <LinkIcon
                          faclass={
                            this.state.showDefaultTargetDateScorecard ?
                              'fa-angle-up' :
                              'fa-angle-down'
                          }
                        />
                      </div>
                    </button>
                    <br/>
                    <SlideDown>
                      <Row>
                      {
                        this.state.showSriOptionScorecards ?
                          currSRIFunds.map((currSRIFund,i)=>{
                            const colWid = currSRIFunds.length > 1 ? 6 : 9
                            return <Col xs={12} sm={12} md={colWid}>
                              <div styleName='fund-card'>
                                <div styleName='title-select-wrap'>
                                  <div styleName='datatitle-sus'>
                                    {currSRIFund.fund_legal_name}
                                    { /* ({currSRIFund.ticker}) */ }
                                  </div>
                                  <img
                                    styleName='sri'
                                    src={sriIcon}
                                    alt='Sustainability mandate'
                                    data-multiline
                                    data-effect='solid'
                                    data-tip={
                                      format.tooltipHtml('Reports a ' +
                                        'Sustainability Mandate to Morningstar. ' +
                                        'Sustainable funds consider issues like the ' +
                                        'environment and human rights.')
                                    }
                                    data-html
                                    data-place='bottom'
                                    data-for='fundname-sri-tooltip'
                                  />
                                  <ReactTooltip id='fundname-sri-tooltip'/>
                                </div>

                                { /* accordion for ESG sectors with slide downs */ }
                                <PlanScorecardFundIssueAccordion
                                  fund={currSRIFund}
                                />

                                { /* render the fund details table */ }
                                <PlanScorecardFundDetails
                                  fund={currSRIFund}
                                />
                              </div>
                            </Col>
                          }) :
                          null
                        }
                      </Row>
                    </SlideDown>
                  </div>
                ) :
                (
                  <div>
                    <br/>
                    <br/>
                  </div>
                )
            }

          </ContainerDivs>

          <br/>
          <br/>

          <PlanScorecardToActionCenter />

          <br/>
          <br/>

          <PlanScorecardSelfDirectedOption
            planData={planData}
          />

          { /* TABLES OF PLAN INVESTMENT OPTIONS WITH RATINGS */ }
          <ContainerDivs>
            <br/>
            <br/>
            <br/>

            <PlanScorecardInvestmentOptions
              planId={planId}
              allocationStats={allocationStats}
              planOptions={planOptions}
            />

            <PlanScorecardSourceData
              planId={planId}
              planData={planData}
              planOptions={planOptions}
            />

            <PlanScorecardCompanyLetter
              planPath={planData.path}
              url={this.props.location}
            />

            <PlanScorecardShareholderResolution
              planId={planId}
              planData={planData}
              url={this.props.location}
            />

          </ContainerDivs>

          <br/>
          <br/>
          <br/>
          <br/>

        </div>
      </div>
    )
  }
}
